import { render, staticRenderFns } from "./ListaNotificaciones.vue?vue&type=template&id=fc909624&scoped=true"
import script from "./ListaNotificaciones.vue?vue&type=script&lang=ts"
export * from "./ListaNotificaciones.vue?vue&type=script&lang=ts"
import style0 from "./ListaNotificaciones.vue?vue&type=style&index=0&id=fc909624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc909624",
  null
  
)

export default component.exports